import ContentBlock from './ContentBlock';

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/ContentBlock/index.js